import styled from 'styled-components';

export const ControlBarContainer = styled.div`
  width: 100%;
  display: flex;
`;

export const ControlBarRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const ControlBarUnSampleContainer = styled.div`
  flex: 0 0 auto;
  margin-left: auto;
`;
